export default "__VITE_ASSET__Db4y6fCK__";